import { render, staticRenderFns } from "./Suduzyz.vue?vue&type=template&id=26f78b3a&scoped=true&"
import script from "./Suduzyz.vue?vue&type=script&lang=js&"
export * from "./Suduzyz.vue?vue&type=script&lang=js&"
import style0 from "./Suduzyz.vue?vue&type=style&index=0&id=26f78b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f78b3a",
  null
  
)

export default component.exports